import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-interval',
  templateUrl: './time-interval.component.html',
  styleUrls: ['./time-interval.component.css']
})
export class TimeIntervalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
